import { Boundaries } from "@planzone/core";
import { projectReport } from "@planzone/dto";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { project, reportId }: Boundaries["retrieveProjectReport"]["request"],
): State {
  return [
    ...state,
    {
      request: setRequestStateToPending(),
      project,
      report: { ...projectReport, uuid: reportId },
      reportId,
    },
  ];
}

function handleSuccess(
  state: State,
  { project, report }: Boundaries["retrieveProjectReport"]["success"],
): State {
  return state.map((res) =>
    res.reportId === report.uuid
      ? { ...res, request: setRequestStateToSuccess(), project, report }
      : res,
  );
}

function handleFailure(
  state: State,
  { reportId }: Boundaries["retrieveProjectReport"]["failure"],
): State {
  return state.map((res) =>
    res.reportId === reportId
      ? { ...res, request: setRequestStateToFailure() }
      : res,
  );
}

function handleEditReport(
  state: State,
  { report }: Boundaries["editProjectReport"]["success"],
): State {
  return state.map((res) =>
    res.reportId === report.uuid ? { ...res, report } : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveProjectReportRequested]: handleRequest,
    [events.retrieveProjectReportSucceeded]: handleSuccess,
    [events.retrieveProjectReportFailed]: handleFailure,
    [events.editProjectReportSucceeded]: handleEditReport,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
